import type { CreationTask } from '../api/creations'
import type { TimelineRound } from '../types/timeline'

/** 时间线骨架张数、结果截断与轮询合并共用：优先 params.n，其次任务 options.n */
export function timelineExpectedImageCount(round: TimelineRound, task?: CreationTask | null): number {
  const fromParams = round.params?.n
  if (typeof fromParams === 'number' && fromParams >= 1) {
    return Math.min(10, Math.floor(fromParams))
  }
  const optN = task?.options?.n
  if (typeof optN === 'number' && optN >= 1) {
    return Math.min(10, Math.floor(optN))
  }
  if (typeof optN === 'string') {
    const parsed = parseInt(optN, 10)
    if (parsed >= 1) return Math.min(10, parsed)
  }
  return 1
}
